import { render } from "./UpdatePersonalDetails.vue?vue&type=template&id=5d0d7fc3&scoped=true"
import script from "./UpdatePersonalDetails.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalDetails.vue?vue&type=script&lang=js"

import "./UpdatePersonalDetails.vue?vue&type=style&index=0&id=5d0d7fc3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0d7fc3"]])

export default __exports__